export enum ClanMemberRole
{
  Leader = 1,
  Member = 2,
}
